<template>
  <section>
    <b-modal :active.sync="isComponentModalActive" has-modal-card :can-cancel="false">
      <div class="modal-card">
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        <header class="modal-card-head">
          <p class="modal-card-title">Usuarios</p>
        </header>
        <section class="modal-card-body">
          <b-field grouped>
            <b-field label="Establecimiento">
              <b-select
                placeholder="Seleccionar"
                v-model="stablishment_id"
                :loading="loading"
                @change.native="chargeLocation(stablishment_id)"
                expanded
              >
                <option
                  v-for="stablishment in listStablishment"
                  :value="stablishment.id"
                  :key="stablishment.id"
                >{{ stablishment.name }}</option>
              </b-select>
            </b-field>
            <b-field label="Locación">
              <b-select
                placeholder="Seleccionar"
                v-model="location_id"
                :loading="loading"
                @change.native="chargeUser(location_id)"
                expanded
              >
                <option
                  v-for="location in listLocation"
                  :value="location.id"
                  :key="location.id"
                >{{ location.name }}</option>
              </b-select>
            </b-field>
          </b-field>
          <div class="box">
            <b-table
              type="is-primary"
              :data.sync="listUsers"
              :loading="loadingTable"
              :paginated="isPaginated"
              :per-page="perPage"
              :current-page.sync="currentPage"
              :pagination-simple="isPaginationSimple"
              :default-sort-direction="defaultSortDirection"
              :sort-icon="sortIcon"
              :sort-icon-size="sortIconSize"
              :is-fullwidth="true"
              default-sort="name"
              aria-next-label="Next page"
              aria-page-label="Page"
              aria-current-label="Current page"
            >
              <template slot-scope="props">
                <b-table-column field="name" label="Nombre" width="40">{{ props.row.name }}</b-table-column>
                <b-table-column
                  field="pather_lastname"
                  label="Apellido Paterno"
                  width="40"
                >{{ props.row.pather_lastname }}</b-table-column>
                <b-table-column
                  field="mother_lastname"
                  label="Apellido Materno"
                  width="40"
                >{{ props.row.mother_lastname }}</b-table-column>
                <b-table-column field="resultado" label="Acciones" width="40">
                  <button class="button is-success is-small" @click='showResult(props.row.id)'>Ver</button>
                </b-table-column>
              </template>
              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <p>
                      <b-icon icon="frown-open" size="is-large"></b-icon>
                    </p>
                    <p>Sin Datos</p>
                  </div>
                </section>
              </template>
              <template slot="bottom-left">
                <b>Total Funcionarios</b>
                : {{ listUsers.length }}
              </template>
            </b-table>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="closeBasic()">Cerrar</button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>
<script>
import { getStablishments } from "../../../services/stablishment";
import { getFindByStablishment } from "../../../services/location";
import { getFindByQuestionarieId } from "../../../services/question_location";
import ShowResult from '../../../components/administrative/chart/showResult';

export default {
  props: ["closeBasic", "isComponentModalActive", "questionary_id"],
  data() {
    return {
      isLoading: false,
      listStablishment: [],
      listLocation: [],
      listUsers: [],
      stablishment_id: "",
      location_id: "",
      loading: false,
      isFullPage: true,
      isPaginated: true,
      loadingTable: false,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 5,
    };
  },
  mounted: function () {
    this.chargeStablishments();
  },

  methods: {
    async chargeStablishments() {
      this.isLoading = true;
      this.loading = true;
      await getStablishments(this.$http).then((response) => {
        this.listStablishment = response;
        this.loading = false;
        this.isLoading = false;
      });
    },
    async chargeLocation(id) {
      this.loading = true;
      this.listLocation = [];
      await getFindByStablishment(this.$http, id).then((response) => {
        this.listLocation = response;
        this.loading = false;
      });
    },
    async chargeUser(location_id) {
      this.loadingTable = true;
      this.listUsers = [];
      await getFindByQuestionarieId(
        this.$http,
        this.questionary_id,
        location_id
      ).then((response) => {
        if (response) {
          this.listUsers = response.location.stablishment.users;
        } else {
          this.listUsers = [];
        }
        this.loadingTable = false;
      });
    },
    showResult(user_id){
        this.$buefy.modal.open({
        parent: this,
        component: ShowResult,
        props: {
            user_id:user_id,
            questionary_id:this.questionary_id,
        },
        hasModalCard: true,
        trapFocus: true,
      });
    }
  },
};
</script>